import { IconMagnifierSlashOutline18 as MagnifierSlashIcon } from "nucleo-ui-outline-18"

export const EmptySearchIllustration = () => (
	<div className="flex size-[3.6rem] items-center justify-center rounded-2xl border border-gray-200 bg-gray-100 opacity-100 dark:border-gray-700/80 dark:bg-gray-800 dark:opacity-100">
		<MagnifierSlashIcon className="size-[1.575rem] text-gray-400 dark:text-gray-500" />
	</div>
)
